module.exports = __webpack_public_path__ + "img/logo_anter.618b15b4.png";